export default __webpack_public_path__ + "static/media/BrownLLWeb-Light.91f47dd3.woff";